export class MvAppShell extends HTMLElement {
  private eyebrow = '';

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback(): void {
    this.render();
  }

  setView(view: HTMLElement, eyebrow: string): void {
    this.eyebrow = eyebrow;

    if (!this.shadowRoot) {
      return;
    }

    const viewContainer = this.shadowRoot.querySelector<HTMLElement>('#view');
    const eyebrowElement = this.shadowRoot.querySelector<HTMLElement>('#eyebrow');
    const mainElement = this.shadowRoot.querySelector<HTMLElement>('#main-content');

    if (!viewContainer || !eyebrowElement || !mainElement) {
      return;
    }

    eyebrowElement.textContent = eyebrow;
    viewContainer.replaceChildren(view);

    requestAnimationFrame(() => {
      mainElement.focus();
    });
  }

  setCurrentPath(_path: string): void {
  }

  private render(): void {
    if (!this.shadowRoot) {
      return;
    }

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          color: #243127;
          display: block;
          min-height: 100vh;
          font-family: 'Gill Sans', 'Trebuchet MS', sans-serif;
          background:
            radial-gradient(circle at top left, rgba(132, 159, 119, 0.3), transparent 24%),
            radial-gradient(circle at top right, rgba(91, 129, 138, 0.18), transparent 26%),
            linear-gradient(180deg, #f6f3ec 0%, #ece2d2 100%);
        }

        * {
          box-sizing: border-box;
        }

        a {
          color: inherit;
        }

        .shell {
          width: min(1180px, calc(100% - 28px));
          margin: 0 auto;
          padding: 18px 0 48px;
        }

        .skip-link {
          position: absolute;
          left: 16px;
          top: 12px;
          transform: translateY(-140%);
          padding: 10px 14px;
          border-radius: 999px;
          background: #ffffff;
          text-decoration: none;
          z-index: 2;
        }

        .skip-link:focus {
          transform: translateY(0);
        }

        #eyebrow {
          text-transform: uppercase;
          letter-spacing: 0.14em;
          font-size: 0.74rem;
          color: #5e6f62;
        }

        main {
          margin-top: 8px;
          outline: none;
        }

        @media (max-width: 720px) {
          .shell {
            width: min(100% - 18px, 1180px);
          }

        }
      </style>

      <a class="skip-link" href="#main-content">Saltar al contenido</a>
      <div class="shell">
        <main id="main-content" tabindex="-1">
          <p id="eyebrow">${this.eyebrow}</p>
          <section id="view" aria-live="polite"></section>
        </main>
      </div>
    `;

    const eyebrowElement = this.shadowRoot.querySelector<HTMLElement>('#eyebrow');

    if (eyebrowElement) {
      eyebrowElement.hidden = this.eyebrow.trim() === '';
    }
  }
}

if (!customElements.get('mv-app-shell')) {
  customElements.define('mv-app-shell', MvAppShell);
}
